import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'JushuitanAfterSale',
    column_type: 'id',
  },
  created_at: {
    model_name: 'JushuitanAfterSale',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'JushuitanAfterSale',
    column_type: 'datetime',
  },
  as_id: {
    model_name: 'JushuitanAfterSale',
    column_type: 'integer',
  },
  outer_as_id: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
  },
  so_id: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
  },
  status: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
  },
  modified: {
    model_name: 'JushuitanAfterSale',
    column_type: 'datetime',
  },
  created: {
    model_name: 'JushuitanAfterSale',
    column_type: 'datetime',
  },
  refund: {
    model_name: 'JushuitanAfterSale',
    column_type: 'decimal',
  },
  real_refund: {
    model_name: 'JushuitanAfterSale',
    column_type: 'decimal',
  },
  receivable_amount: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
  },
  received_amount: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
  },
  order: {
    model_name: 'JushuitanAfterSale',
    column_type: 'belongs_to',
    extra: {
      association_name: 'order',
      model_name: 'JushuitanOrder',
    },
  },
  o_id: {
    model_name: 'JushuitanAfterSale',
    column_type: 'belongs_to',
    extra: {
      association_name: 'order',
      model_name: 'JushuitanOrder',
    },
  },
  shop: {
    model_name: 'JushuitanAfterSale',
    column_type: 'belongs_to',
    extra: {
      association_name: 'shop',
      model_name: 'JushuitanShop',
    },
  },
  shop_id: {
    model_name: 'JushuitanAfterSale',
    column_type: 'belongs_to',
    extra: {
      association_name: 'shop',
      model_name: 'JushuitanShop',
    },
  },
  payment: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
  },
  items: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
  },
  confirm_date: {
    model_name: 'JushuitanAfterSale',
    column_type: 'date',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
